import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SelectComponent } from './internalAdmin/aa-restatement/select/select.component'
import { RestatementComponent } from './internalAdmin/aa-restatement/restatement.component';
import { CompleteComponent } from './internalAdmin/aa-restatement/complete/complete.component'
import { AdminAppComponent } from './_layout/admin/admin.component';
import { RetirementPlanDocumentsComponent } from './admin/retirement-plan-documents/retirement-plan-documents.component';
import { PrintDistributionComponent } from './admin/retirement-plan-documents/print-distribution/print-distribution.component';
import { PrintDistributionBatchComponent } from './admin/retirement-plan-documents/print-distribution-batch/print-distribution-batch.component';
import { SafeHarborComponent } from './internalAdmin/safeharbor/safeHarbor.component';
import { AuthGuard } from './app-common/services/auth-oidc-guard.service';
import { UnauthorizedPageComponent } from './unauthorized-page';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';

const routes: Routes = [
  {
    path: 'internal-administration',
    component: AdminAppComponent,
    canMatch: [AuthGuard],
    children: [
      { path: 'adoption-agreements-20/restatement', component: RestatementComponent },
      { path: 'safeHarbor', component: SafeHarborComponent },
      { path: 'adoptionagreement/select', component: SelectComponent, },
      { path: 'adoptionagreement/complete', component: CompleteComponent, },
    ],
  },
  {
    path: 'admin',
    component: AdminAppComponent,
    canMatch: [AuthGuard],
    children: [
      { path: 'retirement-plan-documents', component: RetirementPlanDocumentsComponent },
      { path: 'retirement-plan-documents/print-distribution/:RetirementSpdId', component: PrintDistributionComponent },
      { path: 'retirement-plan-documents/print-distribution-batch/:RetirementSpdIds', component: PrintDistributionBatchComponent },
    ],
  },
  {
    path: 'unauthorized',
    component: UnauthorizedPageComponent
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy }
  ],
})
export class AppRoutingModule { }
